import SaveAsTemplateModal from './SaveAsTemplateModal.component';

export default SaveAsTemplateModal;
